// extracted by css-extract-rspack-plugin
export default {"Box":"route-title-module__Box__h6ZaA","Octicon":"route-title-module__Octicon__vxu4r","Heading":"route-title-module__Heading__cbsQS"};